// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"b429eb67","134":"799f80d3","182":"4065ee01","276":"637a84cf","410":"96cfee81","738":"a38cd205"}[chunkId] + ".chunk.js";
};